import { fetch, post, changeEmail, changePassword } from './actions';

const getAccount = fetch;
const postAccount = post;

export { getAccount, changeEmail, changePassword };



// WEBPACK FOOTER //
// ./src/app/models/Account/index.ts